import React from 'react';
import { Chip } from '@mui/material';

import KPTable from '../../../../components/KPTComponents/KPTable';

import { ActionColumn } from '../../../../containers/DangKyHoSo/utils';
import { CRUD_MODELS, SCIENTIFIC_RESEARCH_CONSTANTS, SCIENTIFIC_RESEARCH_MODEL } from '../../../../constants';

function BaiBaoTable({ rows, setDialog, setDuyetThanhTich, ...props }) {
  // TODO: useMemo
  const columns = [
    { key: 'orderNumber', width: setDuyetThanhTich ? '5%' : '10%', title: 'STT' },
    { ...SCIENTIFIC_RESEARCH_MODEL.title, width: '25%' },
    { ...SCIENTIFIC_RESEARCH_MODEL.journalTitle, width: '20%' },
    { ...SCIENTIFIC_RESEARCH_MODEL.phase, width: '15%',
      render: (value) => value === 'after' ? 'Sau' : 'Trước',
     },
     { ...SCIENTIFIC_RESEARCH_MODEL.publishedYear, width: '10%' },
    {
      key: 'type',
      align: 'center',
      width: setDuyetThanhTich ? '15%' : '18%',
      label: 'Loại Tạp chí quốc tế uy tín: ISI, Scopus (IF, Qi)',
      render: (_, row) => (
        <>
          <span>{row.journalCoreCollection}</span>
          <br />
          <span>{SCIENTIFIC_RESEARCH_CONSTANTS.TYPE_OPTIONS.find((t) => t.value === row.type)?.title}</span>
          <br />
        </>
      ),
    },
  ];

  if (setDuyetThanhTich) {
    columns.push({
      key: "role",
      label: "Vai trò",
      align: 'center',
      width: '18%',
      render: (_, row) => SCIENTIFIC_RESEARCH_CONSTANTS.ROLE_OPTIONS.find((t) => t.value === row.role)?.title || 'Chưa xác định',
    });
    columns.push({
      key: "numberAuthor",
      label: "Số tác giả",
      align: 'center',
      width: '5%',
      render: (_, row) => row.numberAuthor,
    });
    columns.push({
      key: "numberMain",
      label: "Số tác giả chính",
      align: 'center',
      width: '5%',
      render: (_, row) => row.numberMain,
    });
    columns.push({
      key: 'point',
      label: 'Điểm',
      align: 'center',
      width: '5%',
      render: (_, row) => row.scoringTable?.point
    });
    columns.push({
      key: "point",
      label: "Điểm tối đa",
      align: "center",
      width: "5%",
      render: (_, row) => row.scoringTable?.maxPoint,
    });
    columns.push({
      key: 'note',
      label: 'Ghi chú',
      align: 'center',
      width: '10%',
      render: (_, row) => row.scoringTable?.note
    });
    columns.push({
      key: 'accepted',
      label: 'Trạng thái',
      align: 'center',
      width: '15%',
      render: (_, row) => (
        <Chip
          size='small'
          color={(row.scoringTable?.accepted || row?.notEligible) ? 'primary' : 'default'}
          label={(row.scoringTable?.accepted || row?.notEligible) ? 'Đã chấm' : 'Chưa chấm'}
          variant={(row.scoringTable?.accepted || row?.notEligible) ? 'filled' : 'outlined'}
        />
      ),
    });
  }

  columns.push({
    key: 'link',
    label: 'Tác vụ',
    width: setDuyetThanhTich ? '15%' : '20%',
    render: (_, row) =>
      <ActionColumn
        row={row}
        setDialog={setDialog}
        type={CRUD_MODELS.SCIENTIFIC_RESEARCH}
        filterType={props.filterType}
        setPreview={props.setPreview}
        setDeleteCrud={props.setDeleteCrud}
        setDuyetThanhTich={setDuyetThanhTich}
        setChoDiem={props.setChoDiem}
      />
  });

  return (
    <>
    <KPTable
      columns={columns}
      nonBorder={!!props.nonBorder}
      rows={rows?.filter((row) => row.filterType === props.filterType)}
      // loading={loading}
    />
    {rows?.filter((row) => row.role === 'main' && row.phase === 'after').length >= 0 && (
        <div style={{ margin: '0px 16px 16px 16px' }}>
          <Chip
            label={`Số lượng bài báo ứng viên là tác giả chính sau PGS/TS: ${rows?.filter((row) => row.filterType === props.filterType)?.filter((row) => row.role === 'main' && row.phase === 'after').length}`}
            color='primary'
          />
        </div>
      )}
    </>
  );
}

export default BaiBaoTable;
